import {
  Box,
  Typography,
  IconButton,
  InputBase,
  useMediaQuery,
  Menu,
  MenuItem,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { colors } from "../theme/theme";
import { useLocation, useNavigate } from "react-router-dom";
import {
  MenuOutlined,
  MoreVertOutlined,
  NotificationsOutlined,
  KeyboardArrowDown,
  InboxOutlined,
  MessageOutlined,
  Send,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { clearUserData } from "../redux/actions/user.dispatcher";
import NotificationsMenu from "../Components/NotificationMenu/NotificationMenu";
import axiosInstance from "../utils/config/config";
import { clearPosts } from "../redux/actions/posts.dispatcher";

const NavBar = ({ setState, toggleDrawer }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.user);

  const [search, setSearch] = useState("");
  const [notifications, setNotifications] = useState(null);

  const mediumScreen = useMediaQuery("(max-width:1024px)");
  const smallScreen = useMediaQuery("(max-width:700px)");
  const [navLinks, setNavLinks] = useState(
    userData.role === "admin"
      ? [
          {
            id: 1,
            title: "Dashboard",
            link: "/admin/dashboard",
          },
        ]
      : [
          {
            id: 1,
            title: "Home Page",
            link: "/dashboard",
          },
          {
            id: 2,
            title: "Profile",
            link: "/creator",
          },
          {
            id: 3,
            title: "Community",
            link: "/community",
          },

          {
            id: 4,
            title: "Training Hub",
            link: "/calendar",
          },
        ]
  );

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const fetchNotifications = async () => {
    try {
      const response = await axiosInstance.get(
        "/notification/getAllNotifications"
      );

      setNotifications(response.data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: smallScreen ? "80px" : "120px",
        borderBottom: "1px solid #E0E0E0",
        px: smallScreen ? 1 : 4,
        py: 2,
        backgroundColor: colors.bg,
      }}
    >
      {/* Logo */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        <img
          src={require("../assets/icons/logo-sm.png")}
          style={{
            width: mediumScreen ? "100px" : "150px",
            height: mediumScreen ? "40px" : "60px",
            marginRight: "40px",
            cursor: "pointer",
          }}
          alt="logo"
          onClick={() => navigate("/dashboard")}
        />

        {/* Navigation Links */}
        {!mediumScreen && (
          <Box sx={{ display: "flex", gap: 2 }}>
            {navLinks
              .filter((link) => {
                // if (
                //   link.title === "Creator" &&
                //   userData?.userType !== "creator"
                // ) {
                //   return false;
                // }
                return true;
              })
              .map((link) => (
                <Typography
                  key={link.id}
                  sx={{
                    color: location.pathname.startsWith(link.link)
                      ? colors.primary
                      : "#000",
                    fontFamily: location.pathname.startsWith(link.link)
                      ? "Inter-Bold"
                      : "Inter-Medium",
                    cursor: "pointer",
                    fontSize: "16px",
                  }}
                  onClick={
                    link.link === "/creator"
                      ? () => navigate(`/creator/${userData.id}`)
                      : () => navigate(link.link)
                  }
                >
                  {link.title}
                </Typography>
              ))}
          </Box>
        )}
      </Box>

      {/* Search and Actions */}
      {smallScreen ? (
        <Stack direction={"row"}>
          <IconButton
            onClick={() => {
              navigate("/conversations");
            }}
          >
            <Send sx={{ color: "#000" }} />
          </IconButton>
          <IconButton>
            <NotificationsMenu />
            {/* <NotificationsOutlined sx={{ color: "#000" }} /> */}
          </IconButton>
          {/* <IconButton onClick={() => navigate(`/search/${search}`)}>
            <SearchIcon sx={{ color: "#000" }} />
          </IconButton> */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "50px",
              height: "50px",
              borderRadius: "360px",
              backgroundColor: colors.primary,
            }}
          >
            {userData?.avatar ? (
              <img
                src={userData?.avatar}
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "360px",
                }}
                alt="avatar"
              />
            ) : (
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#fff",
                  fontFamily: "Inter-ExtraBold",
                }}
              >
                {userData?.firstName?.charAt(0)}
                {userData?.lastName ? userData?.lastName?.charAt(0) : ""}
              </Typography>
            )}
          </Box>
          <IconButton onClick={handleClick}>
            <KeyboardArrowDown sx={{ color: "#000" }} className="step-4-1" />
          </IconButton>
          <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
            <MenuItem
              onClick={() => {
                handleClose();
                if (userData.role === "admin") {
                  navigate("/admin/edit-profile");
                } else {
                  navigate("/edit-profile");
                }
              }}
              className="step-4-2"
            >
              Edit Account
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleClose();
                navigate("/onlyhands-helpcenter");
              }}
              className="step-4-2"
            >
              Help Center
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleClose();
                navigate("/community-guidelines");
              }}
              className="step-4-2"
            >
              Community Guidelines
            </MenuItem>
            <MenuItem
              onClick={() => {
                dispatch(clearUserData());
                dispatch(clearPosts());
                localStorage.removeItem("authToken");
                navigate("/login");
              }}
            >
              Logout
            </MenuItem>
          </Menu>
        </Stack>
      ) : (
        // <IconButton onClick={toggleDrawer("right", true)}>
        //   <MenuOutlined sx={{ color: "#000" }} />
        // </IconButton>
        <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
          <IconButton
            onClick={() => {
              navigate("/conversations");
            }}
          >
            <Send sx={{ color: "#E31C25" }} />
          </IconButton>
          <IconButton>
            <NotificationsMenu />
          </IconButton>

          {/* Search Bar */}
          {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: search ? "white" : "#f9f9f9",
              borderRadius: "0px",
              border: search ? "1px double #00000026" : "1px solid #00000026",
              px: 2,
              height: "50px",
              transition: "background-color 0.3s ease",
            }}
            className="step-2-1"
          >
            <InputBase
              placeholder="Search"
              placeholderTextColor="#00000080"
              sx={{
                fontSize: "14px",
                flex: 1,
              }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <IconButton onClick={() => navigate(`/search/${search}`)}>
              <SearchIcon sx={{ color: "#000" }} />
            </IconButton>
          </Box> */}

          {/* User Profile */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "50px",
                height: "50px",
                borderRadius: "360px",
                backgroundColor: colors.primary,
              }}
            >
              {userData?.avatar ? (
                <img
                  src={userData?.avatar}
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "360px",
                  }}
                  alt="avatar"
                />
              ) : (
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#fff",
                    fontFamily: "Inter-ExtraBold",
                  }}
                >
                  {userData?.firstName?.charAt(0)}
                  {userData?.lastName ? userData?.lastName?.charAt(0) : ""}
                </Typography>
              )}
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                {userData?.firstName} {userData?.lastName}
              </Typography>
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#757575",
                }}
              >
                {userData?.userType === "basic" ? "User" : "Creator"}
              </Typography>
            </Box>
          </Box>

          {/* Logout Icon */}
          <IconButton onClick={handleClick}>
            <MoreVertOutlined sx={{ color: colors.primary }} className="" />
          </IconButton>

          <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
            <MenuItem
              onClick={() => {
                handleClose();
                if (userData.role === "admin") {
                  navigate("/admin/edit-profile");
                } else {
                  navigate("/edit-profile");
                }
              }}
            >
              Edit Account
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleClose();
                navigate("/onlyhands-helpcenter");
              }}
            >
              Help Center
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleClose();
                navigate("/community-guidelines");
              }}
            >
              Community Guidelines
            </MenuItem>
            <MenuItem
              onClick={() => {
                dispatch(clearUserData());
                dispatch(clearPosts());
                localStorage.removeItem("authToken");
                navigate("/login");
              }}
            >
              Logout
            </MenuItem>
          </Menu>
        </Box>
      )}
    </Box>
  );
};

export default NavBar;
